// Group 과금 플랜 타입 // TODO: 추후 하나로 사용 예정
export enum GroupPlanType {
  NONE,
  FREE,
  TRIAL,
  ADVANCED,
  ENTERPRISE,
  ADVANCED_PLAN_INV,
  STANDARD = 6,
  PREMIUM = 7,
  STANDARD_TRIAL = 8,
  PREMIUM_TRIAL = 9,
  STANDARD_INVOICE_PAYMENT = 10,
  PREMIUM_INVOICE_PAYMENT = 11,
  ACADEMIC = 12,
  NEW_FREE = 99,
}